export const play = () => (
  <svg
    width="82"
    height="82"
    viewBox="0 0 82 82"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_191_155)">
      <circle
        cx="39"
        cy="39"
        r="34"
        fill="#1B1B1B"
        fillOpacity="0.6"
        shapeRendering="crispEdges"
      />
    </g>
    <path
      d="M54.5 38.134C55.1667 38.5189 55.1667 39.4811 54.5 39.866L32 52.8564C31.3333 53.2413 30.5 52.7602 30.5 51.9904L30.5 26.0096C30.5 25.2398 31.3333 24.7587 32 25.1436L54.5 38.134Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_191_155"
        x="0.7"
        y="0.7"
        width="80.6"
        height="80.6"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="1"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_191_155"
        />
        <feOffset dx="2" dy="2" />
        <feGaussianBlur stdDeviation="2.65" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_191_155"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_191_155"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
